import React, { useState } from 'react';
import ButtonOptions from '../../../../../../../components/NovoSistema/ButtonOptions';
import ButtonsGeneric from '../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import DoubleInput from '../../../../../../../components/NovoSistema/DoubleInput';
import HeaderButtons from '../../../../../../../components/NovoSistema/HeaderButtons';
import InputCheckBox from '../../../../../../../components/NovoSistema/InputCheckBox';
import InputText from '../../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function ProdutoAdd({ setOption }) {
  const [internalOption, setInternalOption] = useState('Principal');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Principal"
          border="#333F50"
          active={internalOption === 'Principal' ? true : false}
          yourFunction={() => setInternalOption('Principal')}
        />
        <ButtonOptions
          buttonName="Vendas"
          border="#333F50"
          active={internalOption === 'Vendas' ? true : false}
          yourFunction={() => setInternalOption('Vendas')}
        />
        <ButtonOptions
          buttonName="Controle"
          border="#333F50"
          active={internalOption === 'Controle' ? true : false}
          yourFunction={() => setInternalOption('Controle')}
        />

        <ButtonOptions
          buttonName="Grade"
          border="#333F50"
          active={internalOption === 'Grade' ? true : false}
          yourFunction={() => setInternalOption('Grade')}
        />

        <ButtonOptions
          buttonName="Divisão Gerencial"
          border="#333F50"
          active={internalOption === 'Divisão Gerencial' ? true : false}
          yourFunction={() => setInternalOption('Divisão Gerencial')}
        />

        <ButtonOptions
          buttonName="Conversão"
          border="#333F50"
          active={internalOption === 'Conversão' ? true : false}
          yourFunction={() => setInternalOption('Conversão')}
        />

        <ButtonOptions
          buttonName="Estoque"
          border="#333F50"
          active={internalOption === 'Estoque' ? true : false}
          yourFunction={() => setInternalOption('Estoque')}
        />

        <ButtonOptions
          buttonName="Imagem"
          border="#333F50"
          active={internalOption === 'Imagem' ? true : false}
          yourFunction={() => setInternalOption('Imagem')}
        />
        <ButtonOptions
          buttonName="Adicionais"
          border="#333F50"
          active={internalOption === 'Adicionais' ? true : false}
          disabled={true}
        />
      </HeaderButtons>
      {internalOption === 'Principal' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Situação"
                  id="Situacao"
                  optionsArray={['Ativo', 'Inativo']}
                  widthPercentage="45%"
                />
                <InputCheckBox title="Bloqueado" id="Bloqueado" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Código" id="Codigo" widthPercentage="45%" />
                <SelectAndOptions
                  title="* Tipo de Produto"
                  id="CodigoLC"
                  optionsArray={[
                    '',
                    'Mercadoria para revenda',
                    'Matéria Prima',
                    'Embalagem',
                    'Produto em Processo',
                    'Produto Acabado',
                    'Subproduto',
                    'Produto Intermediário',
                    'Material de uso e consumo',
                    'Ativo Imobilizado',
                    'Outros Insumos',
                    'Outras',
                  ]}
                  widthPercentage="45%"
                />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="*Descrição" id="DescricaoProduto" widthPercentage="45%" />
                <SelectAndOptions
                  title="* Unidade de medida"
                  id="UnidadeMedida"
                  optionsArray={[
                    '',
                    '_nv | Novo...',
                    'CJ | Conjunto',
                    'CX | Caixa',
                    'FD | Fardo',
                    'GL | Galão',
                    'JG | Jogo',
                    'KG | Quilograma',
                    'LT | Lata',
                    'M | Metro',
                    'PAR | Pares',
                    'PC | Peça',
                    'PCT | Pacote',
                    'RL | Rolo',
                    'SC | Saco',
                    'UN | Unidade',
                  ]}
                  widthPercentage="45%"
                />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="*Descrição Reduzida" id="DescricaoReduzidaProduto" widthPercentage="45%" />
                <InputCheckBox title="Utiliza Conversão" id="UtilizaConversao" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <DoubleInput title="Grade" id="GradeProduto" widthPercentage="45%" />
                <InputCheckBox title="Utiliza Grade" id="UtilizaGrade" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Tipo Cód. de Barras"
                  id="TipoCodeBarrasProduto"
                  optionsArray={['', 'GTIN-8', 'GTIN-12', 'GTIN-13', 'GTIN-14', 'Interno']}
                  widthPercentage="20%"
                />
                <InputText title="Cód. Barras(cEAN)" id="cEAN" widthPercentage="20%" />
                <SelectAndOptions
                  title="Tipo Cód. de Barras Trib"
                  id="TipoCodeBarrasProdutoTrib"
                  optionsArray={['', 'GTIN-8', 'GTIN-12', 'GTIN-13', 'GTIN-14', 'Interno']}
                  widthPercentage="20%"
                />
                <InputText title="Cód. Barras(cEANTrib)" id="cEAN" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Código Referência" id="CodigoRefenciaProduto" widthPercentage="45%" />
                <InputText title="Código de Fábrica" id="CodigoFabricaProduto" widthPercentage="45%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="EX TIPI" id="EXTIPI" widthPercentage="45%" />
                <InputText title="* NCM" id="NCM" widthPercentage="45%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Origem"
                  id="OrigemProduto"
                  optionsArray={[
                    '',
                    '0 - Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8',
                    '1 - Estrangeira - Importação direta, exceto a indicada no código 6',
                    '2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7',
                    '3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento)',
                    '4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/67, e as Leis nºs 8.248/91, 8.387/91, 10.176/01 e 11.484/ 07',
                    '5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento)',
                    '6 - Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução Camex e gás natural.',
                    '7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução Camex e gás natural.',
                    '8 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70% (setenta por cento)',
                  ]}
                  widthPercentage="45%"
                />
                <InputText title="Nº Controle FCI" id="ControleFCI" widthPercentage="45%" />
              </WrapperInputsNewSystem>
              <ContainerSection>
                <h3>Alíquota Tributos Federal Lei 12.741/12</h3>
                <div>
                  <WrapperInputsNewSystem>
                    <InputText title="Federal(%)" id="FederalProduto" widthPercentage="45%" />
                    <InputText title="Estadual(%)" id="EstadualProduto" widthPercentage="45%" />
                  </WrapperInputsNewSystem>
                  <ButtonsGeneric>
                    <button className="success">Atualizar</button>
                  </ButtonsGeneric>
                </div>
              </ContainerSection>
              <ContainerSection>
                <h3>Definições para o PAF-ECF</h3>
                <div>
                  <WrapperInputsNewSystem>
                    <SelectAndOptions
                      title="*IPTT(Indicador de Produção Própria ou de Terceiro)"
                      id="IPTTProduto"
                      optionsArray={['', 'Próprio', 'Terceiros']}
                      widthPercentage="100%"
                    />
                  </WrapperInputsNewSystem>
                </div>
              </ContainerSection>
              <ContainerSection>
                <h3>Mensagem Padrão</h3>
                <div>
                  <WrapperInputsNewSystem>
                    <InputText title="Mensagem" id="MensagemProduto" widthPercentage="100%" />
                  </WrapperInputsNewSystem>
                </div>
              </ContainerSection>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Vendas' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Peso Bruto" id="PesoBruto" widthPercentage="45%" />
                <SelectAndOptions
                  id="UnidadeSelect"
                  optionsArray={['Quilograma', 'Grama', 'Miligrama']}
                  widthPercentage="45%"
                />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Peso Líquido" id="PesoLiquido" widthPercentage="45%" />
                <SelectAndOptions
                  id="UnidadeSelect2"
                  optionsArray={['Quilograma', 'Grama', 'Miligrama']}
                  widthPercentage="45%"
                />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="% Comissão" id="ComissaoProduto" widthPercentage="40%" />
                <SelectAndOptions
                  title="Produto Específico"
                  id="UnidadeSelect2"
                  optionsArray={['', 'Veículo usado', 'Combustível', 'Cerveja']}
                  widthPercentage="40%"
                />
                <InputCheckBox title="Bloquear Descontos/Acréscimos" id="BloquearDescEAcres" />
              </WrapperInputsNewSystem>
              <ContainerSection>
                <h3>Dados Complementares</h3>
                <div>
                  <WrapperInputsNewSystem>
                    <InputCheckBox title="Apresentar essas Informações nos dados adicionais da NF" id="Recibo" />
                  </WrapperInputsNewSystem>
                  <WrapperInputsNewSystem>
                    <textarea rows="5" cols="50"></textarea>
                  </WrapperInputsNewSystem>
                </div>
              </ContainerSection>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'Controle' && (
        <div>
          <ContainerSection>
            <div>
              <h3>Preço</h3>
              <WrapperInputsNewSystem>
                <InputText title="Último valor de compra" id="UltimoValor" widthPercentage="60%" />
                <ButtonsGeneric>
                  <button className="success">Atualizar</button>
                </ButtonsGeneric>
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Porcentagem" id="Porcentagem" widthPercentage="60%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="* Preço" id="Preco" widthPercentage="60%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'Grade' && (
        <div>
          <ContainerSection>
            <div></div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Divisão Gerencial' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <DoubleInput title="Grupo" id="Grupo" widthPercentage="100%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <DoubleInput title="Marca" id="Marca" widthPercentage="100%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <DoubleInput title="Fabricante" id="Fabricante" widthPercentage="100%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <DoubleInput title="Família" id="Familia" widthPercentage="100%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <DoubleInput title="SubTipo" id="SubTipo" widthPercentage="100%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <DoubleInput title="Linha" id="Linha" widthPercentage="100%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <DoubleInput title="Departamento" id="Departamento" widthPercentage="100%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'Conversão' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="* Descrição" id="DescricaoConversao" widthPercentage="30%" />
                <InputText title="* Fator" id="FatorConversao" widthPercentage="30%" />
                <SelectAndOptions title="* UN" id="UNConversa" optionsArray={['']} widthPercentage="30%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Código de Barras" id="CodigoBarrasConversao" widthPercentage="30%" />
                <InputText title="Preço" id="PrecoConversao" widthPercentage="30%" />
              </WrapperInputsNewSystem>
              <ButtonsGeneric>
                <button className="success">+ Adicionar</button>
              </ButtonsGeneric>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'Estoque' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <DoubleInput title="Localização Padrão" id="LocalizacaoPadraoConversao" widthPercentage="30%" />
                <InputText title="Estoque Mínimo" id="EstoqueMinConversao" widthPercentage="20%" />
                <InputText title="Ponto de Pedido" id="PontoPedidoConversao" widthPercentage="20%" />
                <InputText title="Estoque Máximo" id="EstoqueMaxConversao" widthPercentage="20%" />
              </WrapperInputsNewSystem>

              <ContainerSection>
                <h3>Quantidade / Localização inicial de Estoque</h3>
                <div>
                  <WrapperInputsNewSystem>
                    <InputText title="Vendas" id="VendasConversao" widthPercentage="20%" />
                    <InputText title="Custo Médio Unitário" id="CustoMedioConversao" widthPercentage="20%" />
                    <DoubleInput title="Localização" id="LocalizacaoInicialConversao" widthPercentage="40%" />
                  </WrapperInputsNewSystem>
                  <WrapperInputsNewSystem>
                    <InputText title="Uso e Consumo" id="ConsumoConversao" widthPercentage="20%" />
                    <DoubleInput title="Localização" id="LocalizacaoConsumoConversao" widthPercentage="60%" />
                  </WrapperInputsNewSystem>
                </div>
              </ContainerSection>
              <ContainerSection>
                <h3>Produto Relacionado - Baixa do Estoque NFC-e/SAT</h3>
                <div>
                  <WrapperInputsNewSystem>
                    <DoubleInput title="Produto" id="ProdutoRelConversao" widthPercentage="40%" />
                    <InputText title="UN" id="UNRelConversao" widthPercentage="20%" />
                    <InputText title="Fator" id="FatorRelConversao" widthPercentage="20%" />
                  </WrapperInputsNewSystem>
                </div>
              </ContainerSection>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Imagem' && (
        <div>
          <ContainerSection>
            <h3>Imagem</h3>
            <div>
              <ButtonsGeneric>
                <button className="success">Câmera</button>
                <button className="error">Excluir</button>
              </ButtonsGeneric>
              <WrapperInputsNewSystem>
                <input type="file" name="attachments" id="attachments" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
